import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import './PointCauseSaveNavBar.scss';

const PointCauseSaveNavBar = (props) => {
  const { onSubmit } = props;

  return (
    <FixedBottomNavBar className="point-cause-save-navbar">
      <div className="button-group">
        <Button color="primary" text="등록하기" onClick={onSubmit} />
      </div>
    </FixedBottomNavBar>
  );
};

export default PointCauseSaveNavBar;
